import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { AGGREGATOR_TYPE_BADGE } from '../../../../constants/aggregators';
import { memo } from 'react';

function AggregatorTypeForm({ aggregatorType, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Type:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Select
          className="bo-filter"
          name="type"
          id="type"
          value={aggregatorType}
          onChange={changeValue}
        >
          {Object.entries(AGGREGATOR_TYPE_BADGE).map(([key, value]) => (
            <option key={key} value={key}>
              {value.text}
            </option>
          ))}
        </Form.Select>
      </Col>
    </>
  );
}
export default memo(AggregatorTypeForm);
